import AccountingModule from './modules/accounting/Index'
import MarketModule from './modules/market/Index'
import MachineModule from './modules/machine/Index'
import ShopModule from './modules/shop/Index'
import UserModule from './modules/user/Index'


export const childRoutes = [
  {
    path: '/market/instance/list',
    component: MarketModule.InstanceList,
    exactly: true,
  },
  {
    path: '/machine/list',
    component: MachineModule.MachineList,
    exactly: true,
  },
  {
    path: '/accounting/order/list',
    component: AccountingModule.OrderList,
    exactly: true,
  },
  {
    path: '/accounting/recharge/list',
    component: AccountingModule.RechargeList,
    exactly: true,
  },
  {
    path: '/shop/shelf/list',
    component: ShopModule.ShelfList,
    exactly: true,
  },
  {
    path: '/user/list',
    component: UserModule.UserList,
    exactly: true,
  },
  {
    path: '/user/audit/list',
    component: UserModule.UserAuditList,
    exactly: true,
  },
]
